import React from "react";
import ServiceSpace from "../../components/dashboard/ServiceSpace";
import pricing from "../../assets/data/pricing.json";

function UserPlatformJuridique() {
  return (
    <ServiceSpace
      serviceCode="juridique"
      flow="juridique"
      flowPath="/platform-juridique"
      title="Suivi juridique"
      lead="L'accompagnement juridique de votre entreprise."
      offer="Contentieux, contrats d'affaires et secrétariat juridique : nos juristes sécurisent votre activité au quotidien."
      price={Math.min(
        pricing.platformJuridique.mensuel,
        pricing.platformJuridique.annuel,
      )}
    />
  );
}

export default UserPlatformJuridique;
